<template>
    <article>
        <p>
            This inspection detects network issues between the application and the services on which it depends.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/network.png" />
        </v-card>
        
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
